"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.LedgerPanel = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const styled_components_1 = __importDefault(require("styled-components"));
const theme_1 = require("../../theme");
const calculator_styles_1 = require("./calculator-styles");
const format_1 = require("./format");
const Ledger = styled_components_1.default.table `
  width: 100%;
  border-collapse: collapse;
  font-variant-numeric: tabular-nums;

  th {
    ${theme_1.theme.fontLabelBold};
    ${theme_1.theme.fontSize(-1)};
    letter-spacing: 0.13em;
    text-transform: uppercase;
    color: ${theme_1.theme.colors.dimBlue};
    text-align: left;
    padding: 0 0 ${theme_1.theme.spacing(1)};
  }

  th:last-child {
    text-align: right;
  }

  td {
    padding: ${theme_1.theme.spacing(2)} 0;
    border-top: 1px solid ${theme_1.theme.colors.grey(4)};
    ${theme_1.theme.fontNormal};
    ${theme_1.theme.fontSize(0)};
    color: ${theme_1.theme.colors.darkBlue};
    vertical-align: middle;
  }
`;
const Amount = styled_components_1.default.td `
  && {
    text-align: right;
    ${theme_1.theme.fontLabelBold};
    ${theme_1.theme.fontSize(2)};
    letter-spacing: -0.01em;
    white-space: nowrap;
    color: ${(p) => (p.$positive ? theme_1.theme.colors.green : theme_1.theme.colors.red)};
  }
`;
/** Header row that opens one of the two mutually exclusive routes. */
const RouteRow = styled_components_1.default.tr `
  && td {
    border-top: 2px solid ${theme_1.theme.colors.darkBlue};
    padding-bottom: ${theme_1.theme.spacing(0)};
    ${theme_1.theme.fontLabelBold};
    ${theme_1.theme.fontSize(-1)};
    letter-spacing: 0.13em;
    text-transform: uppercase;
    color: ${theme_1.theme.colors.dimBlue};
  }
`;
const NetRow = styled_components_1.default.tr `
  && td {
    border-top: 1px solid ${theme_1.theme.colors.grey(4)};
    ${theme_1.theme.fontLabelBold};
    ${theme_1.theme.fontSize(1)};
  }

  && ${Amount} {
    ${theme_1.theme.fontSize(3)};
  }
`;
const LineNote = styled_components_1.default.span `
  display: block;
  ${theme_1.theme.fontNormal};
  ${theme_1.theme.fontSize(0)};
  color: ${theme_1.theme.colors.dimBlue};
  margin-top: 2px;
`;
const Bar = styled_components_1.default.span `
  display: block;
  height: 7px;
  border-radius: 4px;
  margin-top: 9px;
  min-width: 2px;
  width: ${(p) => p.$width}%;
  background: ${(p) => p.$color};
`;
const LedgerPanel = ({ result }) => {
    const scale = Math.max(result.penaltyAvoided, result.poolProfit, result.ets, Math.abs(result.premium), 1);
    const share = (value) => (Math.abs(value) / scale) * 100;
    const surplus = Math.max(result.surplus, 0);
    return ((0, jsx_runtime_1.jsxs)(calculator_styles_1.Panel, { children: [(0, jsx_runtime_1.jsx)(calculator_styles_1.PanelTitle, { children: "The numbers" }), (0, jsx_runtime_1.jsxs)(calculator_styles_1.PanelBody, { children: [(0, jsx_runtime_1.jsxs)(Ledger, { children: [(0, jsx_runtime_1.jsx)("thead", { children: (0, jsx_runtime_1.jsxs)("tr", { children: [(0, jsx_runtime_1.jsx)("th", { children: "Line" }), (0, jsx_runtime_1.jsx)("th", { children: "USD" })] }) }), (0, jsx_runtime_1.jsxs)("tbody", { children: [(0, jsx_runtime_1.jsxs)("tr", { children: [(0, jsx_runtime_1.jsxs)("td", { children: ["EU ETS cost avoided", (0, jsx_runtime_1.jsx)(LineNote, { children: "Earned either way, on the fuel itself" }), (0, jsx_runtime_1.jsx)(Bar, { "$width": share(result.ets), "$color": theme_1.theme.colors.lightBlue })] }), (0, jsx_runtime_1.jsx)(Amount, { "$positive": result.ets >= 0, children: (0, format_1.formatSigned)(result.ets) })] }), (0, jsx_runtime_1.jsxs)("tr", { children: [(0, jsx_runtime_1.jsxs)("td", { children: ["Biofuel premium paid", (0, jsx_runtime_1.jsx)(Bar, { "$width": share(result.premium), "$color": theme_1.theme.colors.red })] }), (0, jsx_runtime_1.jsx)(Amount, { "$positive": result.premium < 0, children: (0, format_1.formatSigned)(-result.premium) })] }), (0, jsx_runtime_1.jsx)(RouteRow, { children: (0, jsx_runtime_1.jsxs)("td", { colSpan: 2, children: ["Then the surplus \u2014 ", (0, format_1.formatInt)(surplus), " tCO\u2082e, one route or the other"] }) }), (0, jsx_runtime_1.jsxs)("tr", { children: [(0, jsx_runtime_1.jsxs)("td", { children: ["Profit from pooling the compliance", (0, jsx_runtime_1.jsxs)(LineNote, { children: ["Selling the units at $", (0, format_1.formatInt)(result.poolRate), " per tCO\u2082e"] }), (0, jsx_runtime_1.jsx)(Bar, { "$width": share(result.poolProfit), "$color": theme_1.theme.colors.green })] }), (0, jsx_runtime_1.jsx)(Amount, { "$positive": result.poolProfit >= 0, children: (0, format_1.formatSigned)(result.poolProfit) })] }), (0, jsx_runtime_1.jsxs)(NetRow, { children: [(0, jsx_runtime_1.jsx)("td", { children: "Net result, pooling the surplus" }), (0, jsx_runtime_1.jsx)(Amount, { "$positive": result.poolNet >= 0, children: (0, format_1.formatSigned)(result.poolNet) })] }), (0, jsx_runtime_1.jsx)(RouteRow, { children: (0, jsx_runtime_1.jsx)("td", { colSpan: 2, children: "Or instead" }) }), (0, jsx_runtime_1.jsxs)("tr", { children: [(0, jsx_runtime_1.jsxs)("td", { children: ["FuelEU penalty avoided", (0, jsx_runtime_1.jsxs)(LineNote, { children: ["Offsetting your own deficit at $", (0, format_1.formatInt)(result.penaltyRate), " per tCO\u2082e"] }), (0, jsx_runtime_1.jsx)(Bar, { "$width": share(result.penaltyAvoided), "$color": theme_1.theme.colors.lightGreen })] }), (0, jsx_runtime_1.jsx)(Amount, { "$positive": result.penaltyAvoided >= 0, children: (0, format_1.formatSigned)(result.penaltyAvoided) })] }), (0, jsx_runtime_1.jsxs)(NetRow, { children: [(0, jsx_runtime_1.jsx)("td", { children: "Net result, offsetting your own penalty" }), (0, jsx_runtime_1.jsx)(Amount, { "$positive": result.offsetNet >= 0, children: (0, format_1.formatSigned)(result.offsetNet) })] })] })] }), (0, jsx_runtime_1.jsx)(calculator_styles_1.Hint, { children: result.surplus <= 0 ? ((0, jsx_runtime_1.jsxs)(jsx_runtime_1.Fragment, { children: [(0, jsx_runtime_1.jsx)("b", { children: "No surplus at these inputs." }), " Check the biofuel intensity and the FuelEU scope."] })) : ((0, jsx_runtime_1.jsxs)(jsx_runtime_1.Fragment, { children: [(0, jsx_runtime_1.jsxs)("b", { children: ["Break-even biofuel premium: $", (0, format_1.formatInt)(result.tons > 0 ? result.poolValue / result.tons : 0), " ", "per tonne pooling the surplus, $", (0, format_1.formatInt)(result.tons > 0 ? result.offsetValue / result.tons : 0), " ", "offsetting your own penalty."] }), " ", "Below that, the switch pays for itself."] })) })] })] }));
};
exports.LedgerPanel = LedgerPanel;
